import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingComponent} from "./loading.component";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {StickyContainerModule} from "../../../modules/core/component/sticky-container/sticky-container.module";

@NgModule({
    imports: [
        CommonModule,
        MatProgressSpinnerModule,
        StickyContainerModule,
    ],
    exports: [
        LoadingComponent,
    ],
    declarations: [
        LoadingComponent,
    ]
})
export class LoadingModule {}